import { FlaggedKeywordList } from "@verity/components";
import { FlaggedKeyword } from "@verity/database/prisma";
import { useEffect, useState } from "react";
import apiClient from "../../../../helpers/api-client";

const useInstituteKeywords = (instituteUuid?: string) => {
	const [keywords, setKeywords] = useState<FlaggedKeyword[]>([]);
	useEffect(() => {
		if (!instituteUuid) return;
		void apiClient.institute.getSettings(instituteUuid).then((settings) => {
			setKeywords(settings.flaggedKeywords ?? []);
		});
	}, [instituteUuid]);
	return [keywords];
};

export const FlaggedKeywordsTableProvisioned = (props: {
	onSettingChange: (keywords: FlaggedKeyword[]) => void;
	instituteUuid?: string;
}) => {
	const [keywords] = useInstituteKeywords(props.instituteUuid);
	return <FlaggedKeywordList viewingContext="institute" keywords={keywords} onSettingChange={props.onSettingChange} />;
};
